module.exports = __webpack_public_path__ + "img/week-tab-1.2809ad85.png";